import type { UIFBoardCachedDataResult } from '@atlassian/jira-software-uif-early-script/src/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_UIF_BOARD } from './constants.tsx';

export const uifBoardResource = createResource<UIFBoardCachedDataResult | null>({
	type: RESOURCE_TYPE_UIF_BOARD,
	getKey: ({
		match: {
			params: { boardId },
		},
		route: { name: routeName },
		query: { config },
	}) => {
		if (config) {
			return `uif-board::${routeName}::config`;
		}
		if (boardId == null) {
			return `uif-board::${routeName}::not-found`;
		}
		return `uif-board::${routeName}::${boardId}`;
	},
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-uif-board-resource", jiraSpaEntry: "async-uif-board-resource" */ './controllers/get-data'
		),
	maxAge: 0,
});
